/*
 * PLAYXWORLD 404 PAGE — MONOCHROME BRUTALISM
 */
import Layout from "@/components/Layout";
import { Link } from "wouter";

export default function NotFound() {
  return (
    <Layout>
      <section className="bg-white text-black min-h-[60vh] flex items-center justify-center">
        <div className="container text-center py-20">
          <div className="font-heading font-bold text-[10rem] md:text-[14rem] leading-none text-black/10">
            404
          </div>
          <h1 className="font-heading font-bold text-3xl md:text-4xl tracking-tight -mt-8 mb-4">
            ไม่พบหน้าที่ค้นหา
          </h1>
          <p className="text-black/60 mb-8 font-mono text-sm">
            หน้าที่คุณกำลังมองหาอาจถูกย้ายหรือไม่มีอยู่แล้ว
          </p>
          <Link href="/" className="btn-brutal bg-black text-white inline-flex">
            ← กลับหน้าแรก
          </Link>
        </div>
      </section>
    </Layout>
  );
}
